import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Small = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text13']),
        }}
      ></h1>
      <div className={styles.gallery}>
        <div className={styles.imgBox} data-speed="1.2">
          <div>
            <img
              src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-img-palm.jpg"
              alt=""
            />
          </div>

          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text14']),
            }}
          ></h5>
        </div>
        <div className={styles.imgBox}>
          <div>
            <img
              src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-img-pocket.jpg"
              alt=""
            />
          </div>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text15']),
            }}
          ></h5>
        </div>
      </div>
    </div>
  );
};

export default Small;
